<div class="loading-wrapper">
  <span class="loading-container">
    <p-progressSpinner ariaLabel="loading" animationDuration=".5s" />
  </span>
</div>
